import { useState } from 'react'
import { Form } from 'react-bootstrap'
import { AlertTexts, FormTexts, WebViewTexts } from '../../../language/Texts'
import { IFormComponentProps } from '../../../models/IFormComponentProps'
import ColorPicker from '../colorPicker/ColorPicker'
import DateComponent from '../dateComponent/DateComponent'
import DocumentComponent from '../documentComponent/DocumentComponent'
import FormFooter from '../formFooter/FormFooter'
import FormTitle from '../formTitle/FormTitle'
import IconComponent from '../iconComponent/IconComponent'
import InputComponent, { isValidUrl } from '../inputComponent/InputComponent'
import KeyValues from '../keyValues/KeyValues'
import SuccessModal from '../modal/SuccessModal'
import './FormComponent.scss'
import { formSubmit } from './FormSubmit'
import { ComponentType } from '../../../models/componentType.enum'

function FormComponent(props: IFormComponentProps) {
    const [isPrivacyPolicyAccepted, setIsPrivacyPolicyAccepted] = useState(false)
    const [alerOpt, setAlertOpt] = useState({ message: '', loader: false });
    const [modalShow, setModalShow] = useState(false);
    const [showUrlError, setShowUrlError] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        if (!isAllKeyValuesFilled()) {
            return;
        }
        
        // Validate manufacturer URL before submission
        if (props.manufacturerUrl && !isValidUrl(props.manufacturerUrl)) {
            setShowUrlError(true)
            setTimeout(() => {
                setShowUrlError(false)
            }, 3000)
            return;
        }
        
        formSubmit(props, setAlertOpt, setModalShow)
    }

    const isAllKeyValuesFilled = () => {
        let isAllKeyValuesFilled = true;
        for (let i = 0; i < props.keyValues.length; i++) {
            const kv = props.keyValues[i];
            if (kv.key.trim() === '' || kv.value.trim() === '') {
                isAllKeyValuesFilled = false;
                break;
            }
        }
        if (!isAllKeyValuesFilled) {
            setAlertOpt({ message: AlertTexts.fillKeyValue, loader: false });
            setTimeout(() => {
                setAlertOpt({ message: '', loader: false });
            }, 3000);
        }
        return isAllKeyValuesFilled;
    }

    return (
        <Form className={props.type === ComponentType.GEMUE_EXTERNAL ? 'form_wrapper gemue_external' : 'form_wrapper'} onSubmit={handleSubmit} >
            <FormTitle type={props.type} />
            <div className='form_input_pair'>
                <InputComponent
                    componentType={props.type}
                    label={FormTexts.productName}
                    value={props.productName}
                    handleChange={props.setProductName} />
                <InputComponent
                    componentType={props.type}
                    label={FormTexts.serialNumberForm}
                    value={props.serialNumber}
                    handleChange={props.setSerialNumber}
                    isRequired={true} />
            </div>


            <div className='form_input_pair'>
                <InputComponent
                    componentType={props.type}
                    label={WebViewTexts.manufacturerName}
                    value={props.manufacturerName}
                    handleChange={props.setManufacturerName} />
                <InputComponent
                    componentType={props.type}
                    label={WebViewTexts.manufacturerWebseite}
                    value={props.manufacturerUrl}
                    handleChange={props.setManufacturerUrl}
                    type='url'
                    showUrlError={showUrlError}
                    setShowUrlError={setShowUrlError} />
            </div>


            <div className='form_input_pair'>
                <InputComponent
                    componentType={props.type}
                    label={WebViewTexts.materialNumber}
                    value={props.materialNumber}
                    handleChange={props.setMaterialNumber}
                />
                <DateComponent productionDate={props.productionDate} setProductionDate={props.setProductionDate} componentType={props.type} />
            </div>
            <KeyValues keyValues={props.keyValues} setKeyValues={props.setKeyValues} type={props.type} />
            <div className='form_input_pair'>
                <IconComponent componentType={props.type} setIcon={props.setProductIcon} icon={props.productIcon} type={FormTexts.productIcon} />
                <IconComponent componentType={props.type} setIcon={props.setManufacturerIcon} icon={props.manufacturerIcon} type={FormTexts.manufacturerIcon} />
            </div>
            <ColorPicker manufacturerColor={props.manufacturerColor} setManufacturerColor={props.setManufacturerColor} type={props.type} />
            <DocumentComponent files={props.documents} setFiles={props.setDocuments} type={props.type} />
            <FormFooter
                ownerEmail={props.ownerEmail}
                setOwnerEmail={props.setOwnerEmail}
                isPrivacyPolicyAccepted={isPrivacyPolicyAccepted}
                setIsPrivacyPolicyAccepted={setIsPrivacyPolicyAccepted}
                   isAdvertisingAgreed={props.isAdvertisingAgreed}
                setIsAdvertisingAgreed={props.setIsAdvertisingAgreed}
                alertOpt={alerOpt}
                type={props.type}
            />
            <SuccessModal
                show={modalShow}
                type={props.type}
            />
        </Form>
    )
}

export default FormComponent
